export default "__VITE_ASSET__b04e7b8b__"